import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RiesgoCreditoRoutingModule } from './riesgo-credito-routing.module';
import { TendenciaPerdidaComponent } from './tendencia-perdida/tendencia-perdida.component';
import { MatrizTransicionComponent } from './matriz-transicion/matriz-transicion.component';
import { CosechasComponent } from './cosechas/cosechas.component';
import { ConcentracionComponent } from './concentracion/concentracion.component';
import { MayoresDeudoresComponent } from './mayores-deudores/mayores-deudores.component';

import { SharedModule } from '../../shared/shared.module';
import { ReporteComponent } from './reporte/reporte.component';
import { MayoresDeudoresAComponent } from './mayores-deudores-a/mayores-deudores-a.component';
import { ConcentracionAComponent } from './concentracion-a/concentracion-a.component';
import { CoberturaComponent } from './cobertura/cobertura.component';
import { ReservaCarteraComponent } from './reserva-cartera/reserva-cartera.component'; 

@NgModule({
  declarations: [
    TendenciaPerdidaComponent,
    MatrizTransicionComponent,
    CosechasComponent,
    ConcentracionComponent,
    MayoresDeudoresComponent,
    ReporteComponent,
    MayoresDeudoresAComponent,
    ConcentracionAComponent,
    CoberturaComponent,
    ReservaCarteraComponent
  ],
  imports: [
    CommonModule,
    RiesgoCreditoRoutingModule,
    SharedModule
  ]
})
export class RiesgoCreditoModule { }
